import Base from './Base';
import Segment from '../models/Segment';

export default class Segments extends Base {
    get models() {
        const collection = this.data.map(item => new Segment(item));
        collection.collection = this;

        return collection;
    }
}
